module.exports = __webpack_public_path__ + "34b4e800120f2edd4f05844e36fd71e8.svg";